import { BTable, BFormGroup, BFormInput, BFormCheckbox, } from "bootstrap-vue";
import Loading from '@@/core/components/shared/Loading/Loading'

export default {
    name: "SellerDetail",
    components: {
        Loading,
        BTable, BFormGroup, BFormInput, BFormCheckbox
    },
    data() {
        return {
            seller: null,
            sellerRequests: [],
            id: this.$route.params.id,
            page: 1,
            previousPage: 1,
            per_page: 40,
            disabled: true,
        };
    },
    watch: {
        per_page() {
            this.changePage(1)
        }
    },
    created() {
        this.loadData();
    },
    methods: {
        changePage(page = 1) {
            this.previousPage = this.page;
            this.page = page;
            this.loadData()
        },
        numberListItem(list) {
            if(list && list.length){
                let items = list.filter(item => item.status == "pending");
                return items.length;
            }else{
                return "0";
            }
        },
        async loadData() {
            try {
                this.disabled = true;
                const response = await await this.$axios.get("admin/seller-requests/" + this.id, {
                    params: {
                        page: this.page,
                        per_page: this.per_page
                    }
                });
                this.seller = response.data.data.seller;
                this.sellerRequests = response.data.data.requests;
            } catch (e) {
                this.$root.notify(e)
            } finally {
                this.disabled = false;
            }
        }
    },
};